import { Rule } from 'antd/lib/form';
import { RuleObject } from 'rc-field-form/es/interface';
import { DateWorkerNull } from '@models/types';

export const validatePaceTaskExists = (
  customPermittingSectionConfig: { fieldKey: string }[],
  fieldKey: string,
): Rule => ({
  validator: (_: RuleObject, value?: DateWorkerNull): Promise<void> => {
    if (!value) return Promise.resolve();

    const taskExists = customPermittingSectionConfig.some(
      item => item.fieldKey === fieldKey,
    );

    if (!taskExists) {
      return Promise.reject(
        new Error(
          `You have not added the pace task "${fieldKey}" to the screen.`,
        ),
      );
    }

    return Promise.resolve();
  },
});
